import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

interface UserState {
  user: any | null;
  setUser: (user: object) => void;
  resetUser: () => void;
  listView: boolean;
  setListView: (listView: boolean) => void;
}

// initial store
let userStore : any = (set: any) => ({
  user: null,
  setUser: (data: object) => set((state: UserState) => {
    if (state.user) {
      state.user = { ...state.user, ...data }; // merge with existing
    } else {
      state.user = data; // set fresh
    }
  }),
  resetUser: () => set({ user: null }),

  listView: false,
  setListView: (listView: boolean) => set({ listView }),
});

// wrap with immer
userStore = immer(userStore);

// wrap with persist
userStore = persist(userStore, {
  name: "userStorage",
  storage: createJSONStorage(() => sessionStorage),
});

// export hook
export const useUserStore = create<UserState>(userStore);
